// @flow
import React from 'react';
import styled from 'styled-components';
import { SkeletonLine, SkeletonHeading, SkeletonSquare } from '@finect/tabular-components/Skeleton';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { MainContent } from '@finect/tabular-core/MainContent';

export const BankPageContainer = styled.div`
  min-height: 100vh;
`;

const Header = styled.div`
  padding: 24px 0;
`;

const Row = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
`;

/**
 * Estado de carga de las fichas de banco. Antes se pintaba un BankPageContainer vacío,
 * así que "cargando" y "ha fallado" eran visualmente idénticos: una pantalla en blanco.
 */
export const BankSkeleton = () => (
  <BankPageContainer>
    <Container>
      <ContainerInner>
        <MainContent fullWidth>
          <Header>
            <SkeletonHeading h1 />
            <SkeletonLine style={{ width: '45%' }} />
          </Header>

          <Row>
            <SkeletonSquare style={{ width: '33%', height: '120px' }} />
            <SkeletonSquare style={{ width: '33%', height: '120px' }} />
            <SkeletonSquare style={{ width: '33%', height: '120px' }} />
          </Row>

          <SkeletonHeading />
          <SkeletonLine />
          <br />
          <SkeletonLine style={{ width: '80%' }} />
          <br />
          <SkeletonLine style={{ width: '60%' }} />
        </MainContent>
      </ContainerInner>
    </Container>
  </BankPageContainer>
);
